import { render, staticRenderFns } from "./BookingConfirmation.vue?vue&type=template&id=4d13ce58&scoped=true&"
import script from "./BookingConfirmation.vue?vue&type=script&lang=js&"
export * from "./BookingConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d13ce58",
  null
  
)

export default component.exports